import React from "react";
import "containers/Projects/StartProject/Step_1/StartProjectStepOne.css";
import "containers/ProjectCommon.css";
import AxiosConfig from "axiosConfig";
import ProjectBanner from "components/Project/ProjectBanner";
import ProjectOldInfo from "components/Project/Details/ProjectOldInfo";
import ProjectContent from "components/Project/StartProject/Step_1/ProjectContent";
import ProgressStepper from "components/Project/ProgressStepper";
import TextTheme from "components/General/Text/TextTheme";
import TwoButtonLayout from "components/General/Form/CustomButton/TwoButtonLayout";
import imageCompression from "browser-image-compression";
import {validImages} from '../../../../components/Spotlight/Album/ValidFiles';
class StartProjectStepOne extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projectSlug: this.props.match.params.slug,
      projectBadge: "",
      projectBanner: "",
      projectName: "",
      projectCategory: "",
      projectVideo: "",
      projectMission: "",
      projectGoal: "",
      projectVideoName: "",
      projectDateStarted: "Date Started",
      video: "",
      userProjectVideo: "",
      errorMessage: "",
      challengeSlug: this.props.match.params.challenge,
      challengeName: "",
      adventureId: this.props.location.state.adventureId,
      adventureSlug: this.props.location.state.adventureSlug,
      fileType: "",
      imagePopup:true,
      displayImagePopup: false,
      displayCustomPopup:false,
      displayCreationSuite: false,
      fileData:null,
      count:1
    };
    this.openPopUp = this.openPopUp.bind(this);
    this.closePopUp = this.closePopUp.bind(this);
    this.popupControl = this.popupControl.bind(this);
    this.openCustomPopUp = this.openCustomPopUp.bind(this);
    this.fileUpload = this.fileUpload.bind(this);
    this.uploadApi = this.uploadApi.bind(this);
    this.openCreationSuite = this.openCreationSuite.bind(this);
    this.closeCreationSuite = this.closeCreationSuite.bind(this);
    this.handleCreationSuiteUpload = this.handleCreationSuiteUpload.bind(this);
  }
  openPopUp() {
    this.setState({
      displayImagePopup: true,
      count: 1
    })
    this.popupControl();
  }

  closePopUp() {
    this.setState({
      displayImagePopup: false,
      displayCustomPopup: false
    })
  }
  openCreationSuite() {
    this.setState({
      displayCreationSuite: true
    })
  }

  closeCreationSuite() {
    this.setState({
      displayCreationSuite: false,
      displayImagePopup: false,
      displayCustomPopup: false,
      fileData: null,
    })
  }
  uploadApi() {
    const file = this.state.fileData;
    let form_data = new FormData();
    form_data.append("media", file);
    form_data.append("username", '');
    form_data.append("file_type", file.type);
    form_data.append("media_type", this.readMediaType(file.name));
    form_data.append("user_access", 'P');
    form_data.append("media_source", 'U');
    form_data.append("belongs_in", 'A');
    let album_form = form_data;
    album_form.append("belongs_in", 'C');

    AxiosConfig.post('mediaManager/media/', album_form, {//HTPP POST Request
      headers: {
        "content-type": "multipart/form-data",
      },
    }).then(res => {
      this.setState({
        displayCreationSuite: true
      })
    }).catch(err => {
    });

  }
  getExtension(file) {
    let ext = "";
    ext = file.split('.').pop();
    return ext;
  }
  readMediaType(file) {
    let ext = "";
    ext = this.getExtension(file);
    if (validImages().indexOf(ext) > -1) {
      return 'I';
    }
    else {
      return "";
    }
  }
  handleCreationSuiteUpload(val){
    if (val) {
      const file = val;
      const fileType = file.type;
      const fileSize = file.size / 1024;
      const options = {
        maxSizeMB: 2,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      };
      // const videoSize = file.size / 1024 / 1024;
      // if (videoSize > 2) {
      //   this.setState({
      //     errorMessage: "Video is too big in size. Maximum 2MB is accepted",
      //   });
      // } else {
      if (fileType.includes("image")) {
        if (fileSize > 2000) {
          if (fileType.includes("gif")) {
            this.setState({
              video: "",
              userProjectVideo: "",
              errorMessage:
                "Uploaded photo is too big in size. Maximum 2MB accepted for GIFs.",
              fileType: "",
            });
          } else {
            imageCompression(file, options)
              .then((compressedFile) => {
                this.setState({
                  video: URL.createObjectURL(compressedFile),
                  userProjectVideo: compressedFile,
                  errorMessage: "",
                  fileType: "image",
                  imagePopup: false
                });
              })
              .catch((error) => { });
          }
        } else {
          this.setState({
            video: URL.createObjectURL(file),
            userProjectVideo: file,
            errorMessage: "",
            fileType: "image",
            imagePopup: false
          });
        }
      } else if (fileType.includes("video")) {
        this.setState({
          video: URL.createObjectURL(file),
          userProjectVideo: file,
          errorMessage: "",
          fileType: "video",
          imagePopup: false
        });
      } else {
        this.setState({
          video: "",
          userProjectVideo: "",
          errorMessage: "Please upload a video or photo.",
          fileType: "",
        });
      }
    }
  }
  fileUpload(){
    const file = this.state.fileData;
    const fileType = file.type;
    const fileSize = file.size / 1024;
    const options = {
      maxSizeMB: 2,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };
    if (fileSize > 2000) {
          if (fileType.includes("gif")) {
            this.setState({
              video: "",
              userProjectVideo: "",
              errorMessage:
                "Uploaded photo is too big in size. Maximum 2MB accepted for GIFs.",
              fileType: "",
            });
          } else {
            imageCompression(file, options)
              .then((compressedFile) => {
                this.setState({
                  video: URL.createObjectURL(compressedFile),
                  userProjectVideo: compressedFile,
                  errorMessage: "",
                  fileType: "image",
                  imagePopup:false,
                  displayCustomPopup:false,
                  displayImagePopup:false
                });
              })
              .catch((error) => {});
          }
        } else {
          this.setState({
            video: URL.createObjectURL(file),
            userProjectVideo: file,
            errorMessage: "",
            fileType: "image",
            imagePopup: false,
            displayCustomPopup: false,
            displayImagePopup: false
          });
        }
  }
  popupControl(){
    this.setState({
      imagePopup:true
    })
  }
  openCustomPopUp(file) {
    this.setState({
      displayImagePopup: false,
      displayCustomPopup: true,
      fileData: file,
      count: 2,
    })
  }
  videoHandler = (event) => {
    if (event.target.files[0]) {
      const file = event.target.files[0];
      const fileType = file.type;
      const fileSize = file.size / 1024;
      const options = {
        maxSizeMB: 2,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      };
      // const videoSize = file.size / 1024 / 1024;
      // if (videoSize > 2) {
      //   this.setState({
      //     errorMessage: "Video is too big in size. Maximum 2MB is accepted",
      //   });
      // } else {
      if (fileType.includes("image")) {
        this.openCustomPopUp(file);
      } else if (fileType.includes("video")) {
        this.setState({
          video: URL.createObjectURL(file),
          userProjectVideo: file,
          errorMessage: "",
          fileType: "video",
          imagePopup: false
        });
      } else {
        this.setState({
          video: "",
          userProjectVideo: "",
          errorMessage: "Please upload a video or photo.",
          fileType: "",
        });
      }
    }
  };

  moveToStepTwoHandler(event) {
    const {
      projectUserId,
      goalDate,
      challengeSlug,
    } = this.props.location.state;
    const { adventureId, projectSlug, adventureSlug } = this.state;
    if (this.state.userProjectVideo) {
      let form_data = new FormData();
      form_data.append("project", this.state.projectSlug);
      form_data.append(
        "video",
        this.state.userProjectVideo,
        this.state.userProjectVideo.name
      );
      form_data.append("challenge", challengeSlug);
      form_data.append("projectUserId", projectUserId);
      AxiosConfig.put(`impactprojects/start_project_new/`, form_data, {
        headers: {
          "content-type": "multipart/form-data",
        },
      })
        .then(() => {
          if (event === "save") window.location.assign("/projects");
          else
            this.props.history.push({
              pathname: `/projects/${projectSlug}/start-project-step-two`,
              state: {
                challengeSlug: challengeSlug,
                goalDate: goalDate,
                adventureId: adventureId,
                projectSlug: projectSlug,
                adventureSlug: adventureSlug,
                projectUserId: projectUserId,
              },
            });
        })
        .catch();
    } else {
      // this.setState({
      //   errorMessage: "Please upload a photo or video to continue",
      // });
      this.props.history.push({
        pathname: `/projects/${projectSlug}/start-project-step-two`,
        state: {
          challengeSlug: challengeSlug,
          goalDate: goalDate,
          adventureId: adventureId,
          projectSlug: projectSlug,
          adventureSlug: adventureSlug,
          projectUserId: projectUserId,
        },
      });
    }
  }
  onBackButtonEvent = () => {
    this.props.history.push({
      pathname: `/projects/`,
    });
  };
  componentDidMount() {
    const projectSlug = this.state.projectSlug;
    window.onpopstate = (e) => {
      this.onBackButtonEvent();
    };
    AxiosConfig.get(`impactprojects/project/${projectSlug}/`)
      .then((res) => {
        this.setState({
          projectName: res.data["name"],
          projectBanner: res.data["banner"],
          projectBadge: res.data["badge"],
          projectCategory: res.data["category"],
          projectMission: res.data["mission"],
        });
      })
      .catch();
  }

  render() {
    return (
      <div className="header_main">
        <div className="page_main">
          <div className="page_info_vr_content_main">
            <ProjectOldInfo vertical={true} project={this.state.projectSlug} />
          </div>
          <div className="page_details_main">
            <div className="project-banner">
              <ProjectBanner image={this.state.projectBanner} />
            </div>
            <div className="page_info_hr_content_main">
              <ProjectOldInfo
                project={this.state.projectSlug}
                showChallengeDetails={true}
              />
            </div>
            <div className="page_details_content_main mt-15 border-0">
              <div className="stepper_main_content">
                <ProgressStepper
                  currentStep="1"
                  challengeSlug={this.props.location.state.challengeSlug}
                  goalDate={this.props.location.state.goalDate}
                  adventureId={this.state.adventureId}
                  projectSlug={this.state.projectSlug}
                  adventureSlug={this.state.adventureSlug}
                  projectUserId={this.props.location.state.projectUserId}
                  showStepper={true}
                />
              </div>
            </div>
            <div className="page_details_content_main">
              <div className="project-details">
                <ProjectContent
                  videoHandler={this.videoHandler.bind(this)}
                  video={this.state.video}
                  fileData={this.state.fileData}
                  count={this.state.count}
                  closePopUp={this.closePopUp}
                  openPopUp={this.openPopUp}
                  openCreationSuite={this.openCreationSuite}
                  closeCreationSuite = {this.closeCreationSuite}
                  displayImagePopup={this.state.displayImagePopup}
                  displayCustomPopup = {this.state.displayCustomPopup}
                  displayCreationSuite={this.state.displayCreationSuite}
                  fileType={this.state.fileType}
                  fileUpload={this.fileUpload}
                  uploadApi={this.uploadApi}
                  imagePopup={this.state.imagePopup}
                  popupControl = {this.popupControl}
                  handleCreationSuiteUpload = {this.handleCreationSuiteUpload}
                />
              </div>
            </div>
            <div className="mt-15">
              <TextTheme
                message={this.state.errorMessage}
                className="text_small text_red mb-15"
              />
              <TwoButtonLayout
                button1Text="SAVE"
                button2Text="NEXT"
                button1Click={this.moveToStepTwoHandler.bind(this, "save")}
                button2Click={this.moveToStepTwoHandler.bind(this, "move")}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default StartProjectStepOne;
